import { useState, useEffect } from "react"

export function useLocalStorage<T>(key: string, defaultValue?: T) {
  const state = useState<T>(() => {
    const storedVal = localStorage.getItem(key)

    if (storedVal && storedVal !== "undefined") {
      return JSON.parse(storedVal)
    } else {
      return defaultValue
    }
  })

  const [val] = state

  useEffect(() => {
    localStorage.setItem(key, val ? JSON.stringify(val) : "")
  }, [key, val])

  return state
}
